export default __webpack_public_path__ + "static/media/wnew6.fadf56c5.png";